import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const mapSettingsHeatmapsSelector = (state: AppState) => state.map.mapSettings.data.heatmaps.heatmaps;
export const useMapSettingsHeatmapsSelector = () => useSelector(mapSettingsHeatmapsSelector);
